import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { useSnackbar } from "notistack";
import { formatarData, formatarValor } from "../components/formatarValores";
import ItensComprados from "./ItensComprados";
import ReactGA from "react-ga4";

import { useCart } from "../context/CartContext";

function NovoPagamento() {
  const [compra, setCompra] = useState(null);
  const [qrCodeSrc, setQrCodeSrc] = useState("");
  const idCompra = localStorage.getItem("idCompra");
  const { clearCart } = useCart();
  const user = JSON.parse(localStorage.getItem("user"));

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  //GA
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "tela_de_pagamento",
    });

    ReactGA.event({
      category: "Início de pagamento",
      action: "chegou_ao_pix",
      label: user.nome, // optional
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/compras/${idCompra}`
        );
        clearCart();
        setCompra(response.data); // Atualizando o estado com os dados da compra
      } catch (error) {
        console.error("Erro ao buscar compra:", error);
      }
    };

    fetchData();
  }, [idCompra]);

  useEffect(() => {
    if (compra) {
      setQrCodeSrc(compra.chavePix);
    }
  }, [compra]);

  const atualizarStatus = () => {
    const novoStatus = {
      status: "Pagamento em análise",
    };
    axios
      .put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/${idCompra}`,
        novoStatus
      )
      .catch((error) => {
        enqueueSnackbar("Não foi possível atualizar", { variant: "error" });
        console.log(error);
      });
  };

  const copiarParaClipboard = () => {
    const input = document.getElementById("chavePixInput");
    input.select();
    document.execCommand("copy");
    enqueueSnackbar("Chave Pix copiada para área de transferência", {
      variant: "info",
    });
    atualizarStatus();
    setTimeout(() => {
      navigate("/ar/compras");
    }, 1000);
  };
  const gerarChavePIX = async () => {
    const data = {
      codigo: user.id,
      valor: compra.totalPrice,
    };
    ReactGA.event({
      category: "Início de pagamento",
      action: "valor_do_pix",
      value: compra ? compra.totalPrice / 100 : null, // optional
    });
    try {
      const response = await axios.post(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/compras/pagamento/gerarPayload`,
        data
      );

      setQrCodeSrc(response.data.chavePix);
      salvarNovoQr(response.data.chavePix);
      return response.data;
    } catch (error) {
      console.error("Problemas na geração do QRCODE", error);
    }
  };

  const salvarNovoQr = async (chavePix) => {
    try {
      const data = {
        chavePix,
      };
      const response = await axios.put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/${idCompra}`,
        data
      );
    } catch (error) {
      console.error("Problemas ao salvar o novo QRCODE", error);
    }
  };

  return (
    <div className="p-6 bg-base-100 flex flex-col justify-center items-center mt-20">
      <div className="container flex flex-col max-w-xl shadow-lg rounded-lg p-3 bg-base-200">
        <div>
          <h1 className="mb-3 text-center text-[22px]">Sua compra</h1>
        </div>
        <div className="flex space-x-16 justify-center mb-2">
          <div className="flex ">
            <div>
              <strong>Data:</strong>{" "}
            </div>
            <div className="ml-1">
              {compra ? formatarData(compra.dataCompra) : "Carregando..."}
            </div>
          </div>
          <div className="flex ">
            <div>
              <strong>Fotos:</strong>{" "}
            </div>
            <div className="ml-1">
              {compra ? compra.quantity : "Carregando..."}
            </div>
          </div>
        </div>
        <div className="justify-center">
          <div className="flex flex-col justify-center align-baseline mx-4">
            <div className="flex justify-center">
              <label className="pr-2 pt-3 text-[16px]">Total </label>
              <span className="text-[16px] pt-3 pr-1">R$</span>{" "}
              <span className="text-[50px] py-0">
                <strong className="py-0">
                  {compra ? formatarValor(compra.totalPrice) : "Carregando..."}
                </strong>
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-center">
          <strong className="align-middle pt-1 pr-1">Status: </strong>
          <div
            className={
              (compra && compra.status === "Pendente") || "Em processamento"
                ? "text-orange-500 text-[20px]"
                : "text-green-500 text-[20px]"
            }
          >
            {compra ? compra.status : "Carregando..."}
          </div>
        </div>
      </div>
      {compra && compra.status === "Pago" ? null : (
        <>
          {compra ? (
            <div className=" text-gray-500 flex justify-center flex-col mt-4">
              <div>
                <label>Instruções:</label>
                <ul>
                  <li>1. Acesse o app do seu banco e vá até a área do PIX</li>
                  <li>2. Procure por PIX COPIA E COLA</li>
                  <li>
                    3. Cole o código, confira os dados e finalize o pagamento.
                  </li>
                </ul>
              </div>
              <div className="flex flex-col items-center my-4 ">
                <input
                  id="chavePixInput"
                  className="border border-gray-300 p-2 justify-self-end text-gray-400 m-2 bg-base-100 rounded w-60"
                  value={qrCodeSrc}
                  readOnly
                />
                <button
                  className="bg-blue-500 text-white p-2 rounded w-60"
                  onClick={copiarParaClipboard}
                >
                  Copiar código
                </button>
              </div>
              <div className=" flex items-center flex-col">
                {qrCodeSrc ? (
                  <QRCode value={qrCodeSrc} />
                ) : (
                  <p>QR Code não disponível.</p>
                )}
                <button
                  className="bg-gray-500 text-white p-2 mt-4 rounded w-30"
                  onClick={gerarChavePIX}
                >
                  Gerar novo código
                </button>
              </div>
            </div>
          ) : (
            <p>Carregando...</p>
          )}

          <div className="m-4">
            <a>
              Assim que o pagamento for identificado as fotos sem marca d'água
              estarão disponíveis para baixar. Fica tranquila, que avisarei pelo
              WhatsApp.
            </a>
          </div>
        </>
      )}
      <ItensComprados
        produtos={compra ? compra.produtos : null}
        pagamento={compra ? compra.status : null}
      />
      <p className="mt-2">
        Se tiver qualquer problema, me chama, que ajudo. Só clicar no ícone:
        <a
          className="link flex justify-center align-bottom text-green-950"
          href="http://wa.me/5511976006882/?text=Oi,%20Adauto.%20Me%20ajuda?"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="50px"
            width="50px"
            viewBox="0 0 448 512"
          >
            <path
              fill="green"
              d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
            />
          </svg>
        </a>
      </p>
    </div>
  );
}

export default NovoPagamento;
